export type WcsTabsAlignment = 'start' | 'center' | 'end';

export interface WcsTabChangeEvent {
    tabName: string;
    tabIndex: number;
    selectedKey: any;
}
